import { type InternalAxiosRequestConfig } from 'axios';

/**
 * Check request url and remove double slashes
 * @param config Axios request config
 */
export const urlWithoutDoubleSlashesInterceptor = (config: InternalAxiosRequestConfig) => {
  if (config.url) {
    config.url = config.url.replace(/([^:]\/)\/+/g, '$1');
  }
  return config;
};
